import { FormEvent, useState } from "react";
import { toast } from "@/utils/appToast";
import { api } from "@/utils/api";
import CustomButton from "@/shared/button/customButton";
import { useTranslation } from 'react-i18next';
import { IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useSearchParams } from "react-router-dom";

type ResetPasswordFormProps = {
  email: string;
  onHide: () => void;
  token?: string;
  onGoToLogin: () => void; // ✅ NEW prop
  forcePasswordReset: boolean,
  resetUserId: string
};

const ResetPassword = ({ onHide, token, onGoToLogin , forcePasswordReset , resetUserId}: ResetPasswordFormProps) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
 const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [searchParams] = useSearchParams();

  const email = searchParams.get("email");
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const formData = new FormData(e.currentTarget);
      const newPassword = formData.get("password") as string;
      const confirmPassword = formData.get("confirmPassword") as string;

      if (newPassword.length < 6) {
  toast.error("La contraseña debe tener al menos 6 caracteres");
        setIsLoading(false);
        return;
      }

      if (newPassword !== confirmPassword) {
  toast.error("Las contraseñas no coinciden");
        setIsLoading(false);
        return;
      }

      const data = await api.resetPassword({
        type: "email",
        newPass: newPassword,
        passRecoveryCode: token,
        forcePasswordReset,
        userId:resetUserId,
        email: email
      });

      if (data.success) {
  toast.success("Contraseña restablecida con éxito");

        // ✅ Delay slightly and go to login popup
        setTimeout(() => {
          onHide()
          onGoToLogin();
        }, 1000);
      }
    } catch (error) {
     
  toast.error(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (

    <div className="login-form default-form">
      <div className="form-inner">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          {/* <JandiSymbol alt /> */}
          <img
            src="/images/phone_symbol.svg"
            alt="Phone Symbol"
            style={{
              width: '60px',
              height: '60px',
              display: 'block'
            }}
          />
        </div>

        <h3 className="text-center" style={{ color: "white", fontWeight: 600 }}>{t('forgotPassword')}</h3>

        <form method="post" onSubmit={handleSubmit}>

       <div className="form-group" style={{ position: "relative" }}>
  <label className="text-white">
    {t('newPassword')} <span style={{ color: "red" }}> *</span>
  </label>

  <div style={{ position: "relative" }}>
    <input
      type={showNewPassword ? "text" : "password"}
      name="password"
      className="form-control rounded-md"
      placeholder={t('enterNewPassword')}
      required
      style={{
        borderRadius: 0,
        height: "50px",
        fontSize: "16px",
        padding: "10px 20px",
        width: "100%",
      }}
    />

    <IconButton
      onClick={() => setShowNewPassword(prev => !prev)}
      style={{
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        color: "black",
      }}
    >
      {showNewPassword ? <VisibilityOff /> : <Visibility />}
    </IconButton>
  </div>
</div>


         <div className="form-group" style={{ position: "relative" }}>
  <label className="text-white">
    {t('confirmPassword')} <span style={{ color: "red" }}> *</span>
  </label>

  <div style={{ position: "relative" }}>
    <input
      type={showConfirmPassword ? "text" : "password"}
      name="confirmPassword"
      className="form-control rounded-md"
      placeholder={t('confirmNewPassword')}
      required
      style={{
        borderRadius: 0,
        height: "50px",
        fontSize: "16px",
        padding: "10px 20px",
        width: "100%",
      }}
    />

    <IconButton
      onClick={() => setShowConfirmPassword(prev => !prev)}
      style={{
        position: "absolute",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)",
        color: "black",
      }}
    >
      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
    </IconButton>
  </div>
</div>


          <div className="form-group">

          <div className="form-group">
          <button
            className="theme-btn btn-style-one rounded-3xl"
            type="submit"
            name="log-in"
            disabled={isLoading}
            style={{ backgroundColor: "black" }}
          >
            {isLoading ? (
              <div
                className="spinner-border"
                style={{ height: "15px", width: "15px" }}
                role="status"
              ></div>
            ) : (
              t('resetPassword')
            )}
          </button>
        </div>

            {/* <button
              className="theme-btn btn-style-one w-100"
              type="submit"
              disabled={isLoading}
              style={{
                backgroundColor: "#1967d2",
                border: "none",
                height: "50px",
                fontSize: "16px",
                borderRadius: 14,
              }}
            >
              {isLoading ? (
                <div className="spinner-border spinner-border-sm" role="status"></div>
              ) : (
                "Restablecer contraseña"
              )}
            </button> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
